module.exports = __webpack_public_path__ + "static/img/practiceSystem_01.077e4ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/practiceSystem_01.png
// module id = xmkK
// module chunks = 23